export default __webpack_public_path__ + "static/media/pyposition_84c_big.b6a39c4b.png";